<div class="overlay-wrapper fw fh {{currentLink}}" [hidden]="!showLoader">
    <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
</div>